<template>
  <div>
  <ErrorLayout :texto="textError" :titulo="'Erro no carregamento'" :show-btn="false"></ErrorLayout>
  </div>
</template>
<script>
import ErrorLayout from '@/components/Error/ErrorLayout'
export default {
  components: {
    ErrorLayout
  },
  computed: {
    textError () {
      return 'O sistema está passando por instabilidade e não pôde carregar os dados.' +
        'Tente novamente ou fale com a Central de Atendimento'
    }
  }
}
</script>
